var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "M0-682.665H21.217v21.217H0Z",
    transform: "translate(0 682.665)",
    fill: "#262626"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Team_Inactive",
    transform: "translate(-49 -109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Team_Inactive-2",
    "data-name": "Team_Inactive",
    transform: "translate(50 110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g412",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g418",
    transform: "translate(1.332 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M-81.648-20a2.622,2.622,0,0,1,2.619,2.619,2.622,2.622,0,0,1-2.619,2.619,2.622,2.622,0,0,1-2.619-2.619A2.622,2.622,0,0,1-81.648-20Zm0,3.995a1.377,1.377,0,0,0,1.376-1.376,1.377,1.377,0,0,0-1.376-1.376,1.377,1.377,0,0,0-1.376,1.376A1.377,1.377,0,0,0-81.648-16.005Z",
    transform: "translate(84.266 20)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g422",
    transform: "translate(14.647 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path424",
    d: "M-81.648-20a2.622,2.622,0,0,1,2.619,2.619,2.622,2.622,0,0,1-2.619,2.619,2.622,2.622,0,0,1-2.619-2.619A2.622,2.622,0,0,1-81.648-20Zm0,3.995a1.377,1.377,0,0,0,1.376-1.376,1.377,1.377,0,0,0-1.376-1.376,1.377,1.377,0,0,0-1.376,1.376A1.377,1.377,0,0,0-81.648-16.005Z",
    transform: "translate(84.266 20)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g426",
    transform: "translate(7.989 11.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path428",
    d: "M-81.648-20a2.622,2.622,0,0,1,2.619,2.619,2.622,2.622,0,0,1-2.619,2.619,2.622,2.622,0,0,1-2.619-2.619A2.622,2.622,0,0,1-81.648-20Zm0,3.995a1.377,1.377,0,0,0,1.376-1.376,1.377,1.377,0,0,0-1.376-1.376,1.377,1.377,0,0,0-1.376,1.376A1.377,1.377,0,0,0-81.648-16.005Z",
    transform: "translate(84.266 20)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g430",
    transform: "translate(13.038 8.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path432",
    d: "M-147.946-10.106a.622.622,0,0,1-.565-.362.622.622,0,0,1,.305-.824,6.727,6.727,0,0,0,3.91-6.094,6.7,6.7,0,0,0-.253-1.828.622.622,0,0,1,.429-.767.622.622,0,0,1,.767.429,7.949,7.949,0,0,1,.3,2.167,7.973,7.973,0,0,1-4.634,7.223A.619.619,0,0,1-147.946-10.106Z",
    transform: "translate(148.568 20.005)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g434",
    transform: "translate(2.663 8.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path436",
    d: "M-152.557-288.616a.619.619,0,0,1-.259-.057,7.973,7.973,0,0,1-4.634-7.223,7.947,7.947,0,0,1,.3-2.167.622.622,0,0,1,.768-.429.622.622,0,0,1,.429.768,6.7,6.7,0,0,0-.253,1.828,6.727,6.727,0,0,0,3.91,6.094.622.622,0,0,1,.305.824A.622.622,0,0,1-152.557-288.616Z",
    transform: "translate(157.45 298.515)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g438",
    transform: "translate(5.539 3.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "M-10.485-65.718a.619.619,0,0,1-.378-.128,6.636,6.636,0,0,0-4.07-1.378A6.636,6.636,0,0,0-19-65.846a.622.622,0,0,1-.871-.115.622.622,0,0,1,.115-.871,7.869,7.869,0,0,1,4.826-1.634,7.869,7.869,0,0,1,4.826,1.634.622.622,0,0,1,.115.871A.621.621,0,0,1-10.485-65.718Z",
    transform: "translate(20.001 68.468)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g442",
    transform: "translate(6.658 15.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path444",
    d: "M-226.943-121.207H-233.6a.622.622,0,0,1-.622-.622v-1.332a3.955,3.955,0,0,1,3.951-3.951,3.955,3.955,0,0,1,3.951,3.951v1.332A.622.622,0,0,1-226.943-121.207Zm-6.036-1.243h5.415v-.71a2.71,2.71,0,0,0-2.707-2.707,2.71,2.71,0,0,0-2.707,2.707Z",
    transform: "translate(234.222 127.11)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g446",
    transform: "translate(0 3.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "M-226.943-121.207H-233.6a.622.622,0,0,1-.622-.622v-1.332a3.955,3.955,0,0,1,3.951-3.951,3.955,3.955,0,0,1,3.951,3.951v1.332A.622.622,0,0,1-226.943-121.207Zm-6.036-1.243h5.415v-.71a2.71,2.71,0,0,0-2.707-2.707,2.71,2.71,0,0,0-2.707,2.707Z",
    transform: "translate(234.222 127.11)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g450",
    transform: "translate(13.316 3.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path452",
    d: "M-226.943-121.207H-233.6a.622.622,0,0,1-.622-.622v-1.332a3.955,3.955,0,0,1,3.951-3.951,3.955,3.955,0,0,1,3.951,3.951v1.332A.622.622,0,0,1-226.943-121.207Zm-6.036-1.243h5.415v-.71a2.71,2.71,0,0,0-2.707-2.707,2.71,2.71,0,0,0-2.707,2.707Z",
    transform: "translate(234.222 127.11)",
    fill: "#262626"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14859",
    "data-name": "Rectangle 14859",
    width: 23,
    height: 23,
    transform: "translate(49 109)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamInactive);
export default __webpack_public_path__ + "static/media/team_inactive.777257e3.svg";
export { ForwardRef as ReactComponent };